/* eslint-disable react/prop-types */
import { Alert, Snackbar } from "@mui/material";

function CustomAlert({ alert, onClose }) {
  const handleCloseAlert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    onClose?.();
  };
  return (
    alert &&
    alert.alert && (
      <Snackbar
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={alert.alert}
        onClose={handleCloseAlert}
      >
        <Alert onClose={handleCloseAlert} severity={alert.type}>
          {alert.message}
        </Alert>
      </Snackbar>
    )
  );
}

export default CustomAlert;
